import React from 'react';
import { useCart } from '../CartContext';

export function Toast() {
  const { toast } = useCart();
  return (
    <div className={`toast ${toast.visible ? 'show' : ''}`}>
      ✓ {toast.message}
    </div>
  );
}

export function FloatingCartButton() {
  const { cartCount, setIsCartOpen } = useCart();
  return (
    <button className="floating-cart-btn" onClick={() => setIsCartOpen(true)} aria-label="Open Cart">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="20" r="1.5" fill="currentColor" stroke="none"/>
        <circle cx="17" cy="20" r="1.5" fill="currentColor" stroke="none"/>
        <path d="M3 4h2l2.5 11h9.5l2-7H7"/>
        <path d="M9.5 15h8"/>
      </svg>
      {cartCount > 0 && (
        <span style={{ position: 'absolute', top: '-4px', right: '-4px', background: '#ef4444', color: 'white', fontSize: '11px', fontWeight: 700, width: 20, height: 20, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid white', lineHeight: 1 }}>
          {cartCount}
        </span>
      )}
    </button>
  );
}
